export enum TEACHER_PAYOUT_STATUS {
  PENDING = "pending",
  APPROVED = "approved",
  FAILED_TO_SEND = "failed_to_send",
  PAYMENT_ERROR = "payment_error",
  PAYMENT_PROCESSING = "payment_processing",
  PAID = "paid",
}
